import { Select } from '../../input';
import { Error } from '../../error';

const visiterChoices = [
  ['fetch', 'fetch()'],
  ['playwright', 'Playwright'],
];

export const VisiterInput = ({ params, onChange, errors }) => (
  <>
    <Select
      label="Rendering"
      noEmpty
      style={{ width: 120 }}
      value={params.visiter}
      onChange={(val) => onChange('visiter', val)}
      choices={visiterChoices}
    />
    <Error message={errors?.visiter} />
  </>
);
